<template>
  <v-container id="user-profile" fluid tag="section">
    <v-row justify="center">
      <v-col cols="12" lg="8" md="12">
        <base-material-card
          icon="mdi-office-building"
          color="primary"
          class="small-icon"
          :title="
            id
              ? $i18n.t('Edit Campus - ') + campus.name
              : $i18n.t('Create Campus')
          "
        >
          <v-form id="form">
            <v-container class="py-0">
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                    :label="$i18n.t('Name')"
                    dense
                    v-model="campus.name"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="4">
                  <z-country-select
                    class="purple-input"
                    v-model="campus.address.country"
                  ></z-country-select>
                </v-col>

                <v-col cols="12" md="4">
                  <z-state-select
                    class="purple-input"
                    v-model="campus.address.state"
                    :country="campus.address.country"
                  ></z-state-select>
                </v-col>

                <v-col cols="12" md="4">
                  <z-city-select
                    class="purple-input"
                    v-model="campus.address.city"
                    :state="campus.address.state"
                    :country="campus.address.country"
                  ></z-city-select>
                </v-col>

                <v-col cols="12" md="6">
                  <v-text-field
                    :label="$i18n.t('Address')"
                    dense
                    v-model="campus.address.addressLine"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="12">
                  <v-row>
                    <gmap-map
                      :center="center"
                      :zoom="12"
                      style="width:100%;  height: 450px;"
                      ref="mapRef"
                    >
                      <gmap-marker
                        :key="index"
                        v-for="(m, index) in markers"
                        :position="m.position"
                        @click="center = m.position"
                      ></gmap-marker>
                    </gmap-map>
                    <div style="width:100%;position: absolute;">
                      <gmap-autocomplete
                        @place_changed="setPlace"
                        :label="$i18n.t('Seach Location')"
                      ></gmap-autocomplete>
                    </div>
                    <div
                      style="top:-275px; width:50px;position:relative; margin:auto"
                    >
                      <v-icon style="font-size: 50px;" color="red"
                        >mdi-map-marker</v-icon
                      >
                    </div>
                  </v-row>
                </v-col>

                <v-col cols="12" class="text-right">
                  <v-btn
                    color="success"
                    class="mr-0"
                    @click="save()"
                    :loading="loading"
                  >
                    <h3>{{ $i18n.t("Save") }}</h3>
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import { doGet, doPost } from "@/store/common/module/apis";
import common from "@/store/common/module/common";
import init from "@/store/common/module/init";

@Component
export default class Tickets extends Vue {
  campus = {
    name: "",
    address: { country: "", state: "", city: "", addressLine: "" },
  };

  id = null;
  center = { lat: 45.508, lng: -73.587 };
  markers = [];
  places = [];
  currentPlace = null;
  map = null;

  get loading() {
    return common.loading;
  }

  async save() {
    this.campus.address.lat = this.map.getCenter().lat();
    this.campus.address.lon = this.map.getCenter().lng();
    try {
      common.setLoading(true);
      this.campus = await doPost("/api/campus/save/return", this.campus);
      this.$router.push("/settings/campus/" + this.campus._id);
      this.get(this.campus._id);
      common.showMessage("Saved Successfully");
      common.setLoading(false);
    } catch (e) {
      common.setError(e.message);
      common.setLoading(false);
    }
  }

  async get(id) {
    try {
      this.campus = await doGet("/api/campus/" + id + "/detail");
      this.id = this.campus._id;
      if (this.campus.address.lat) {
        this.center = {
          lat: this.campus.address.lat,
          lng: this.campus.address.lon,
        };
      }
    } catch (e) {
      common.setError(e.message);
    }
  }

  async mounted() {
    if (this.$route.params.id) {
      await this.get(this.$route.params.id);
    }
    await init.getUrlParameter("forCorp");
    if (init.urlParam) {
      this.campus.corp_id = init.urlParam;
    }
    this.$refs.mapRef.$mapPromise.then((map) => {
      this.map = map;
    });
  }

  setPlace(place) {
    this.currentPlace = place;
    this.center = place.geometry.location;
  }
}
</script>

<style scoped>
.pac-target-input {
  width: 50%;
  border: 1px solid #dfdfdf;
  height: 30px;
  padding: 10px 20px;
  z-index: 1;
  background: white;
  margin-left: 25%;
  position: absolute;
  margin-top: 10px;
}
</style>
